export enum AuthType {
    Graph = 1,
}